import { ClientEntity } from './ClientEntity'
import { ClientCharacter } from './ClientCharacter'
import { ClientContainer } from './ClientContainer'
import { ClientCorpse } from './ClientCorpse'
import { ClientHarvestNode } from './ClientHarvestNode'
import { ClientStation } from './ClientStation'
import { ClientPortal } from './ClientPortal'

const entityClasses = {}
for (const cls of [ClientCharacter, ClientContainer, ClientCorpse, ClientHarvestNode, ClientStation, ClientPortal]) {
  entityClasses[cls.type] = cls
}

export function createClientEntity(world, data) {
  const EntityClass = entityClasses[data.type] || ClientEntity
  const entity = new EntityClass(world, data)
  entity.initialize?.()
  return entity
}
